import { TDeviceType } from '@cian/ui-kit';

interface ICreatePage {
  deviceType: TDeviceType;
  extra: {
    [key: string]: string;
  };
}

export function createCianAnalyticsPageWithExtra({ extra, deviceType }: ICreatePage) {
  return {
    pageType: 'Home',
    siteType: deviceType,
    extra,
  };
}
